<template>
  <page>
    <template v-slot:header>
      <CCol xs="12" sm="4" class="offset-sm-4">
        <div class="text-center">
          <h1 class="mb-3 font-5xl">
            {{ $t(`legal.pages.terms-and-conditions.titlePage`) }}
          </h1>
        </div>
      </CCol>
    </template>
    <div class="mt-5 pt-3 pl-5 pr-5 mb-5 text-header4">
      <h2 class="text-center">{{ $t(`termosAndCondition.header.title`) }}</h2>
      <h3 class="mt-3 text-center">{{ $t(`termosAndCondition.header.subTitle`) }}</h3>
      <h3 class="mt-2 text-center">{{ $t(`termosAndCondition.header.subTitleDetails`) }}</h3>
      <br />

      <div>
        <h3 class="mt-5">{{ $t(`termosAndCondition.topics.topic1.title`) }}</h3>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic1.text`) }}</p>
      </div>
      <div>
        <h3 class="mt-4">{{ $t(`termosAndCondition.topics.topic2.title`) }}</h3>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic2.text`) }}</p>
      </div>
      <div>
        <h3 class="mt-4">{{ $t(`termosAndCondition.topics.topic3.title`) }}</h3>
        <br />
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic3and1.title`) }}</h4>
        <ul class="mt-3">
          <li class="term-text" v-for="item in $t(`termosAndCondition.topics.topic3and1.items`)" :key="item">&bull; {{ item }}</li>
        </ul>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic3and2.title`) }}</h4>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic3and3.title`) }}</h4>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic3and4.title`) }}</h4>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic3and5.title`) }}</h4>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic3and6.title`) }}</h4>
      </div>
      <div>
        <h3 class="mt-5">{{ $t(`termosAndCondition.topics.topic4.title`) }}</h3>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic4and1.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic4.text`) }}</p>
        <ul class="mt-3">
          <!-- TODO: Método alternativo devido quebra do plano trial em live REMOVER -->
          <li class="term-text" v-for="item in $t(`termosAndCondition.topics.topic4and1.items-trial`)" :key="item">&bull; {{ item }}</li>
        </ul>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic4and2.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic4and2.text`) }}</p>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic4and3.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic4and3.text`) }}</p>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic4and4.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic4and4.text`) }}</p>
      </div>
      <div>
        <h3 class="mt-4">{{ $t(`termosAndCondition.topics.topic5.title`) }}</h3>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic5and1.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic5and1.text-trial`) }}</p> <!-- TODO: Método alternativo devido quebra do plano trial em live REMOVER -->
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic5and2.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic5and2.text`) }}</p>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic5and3.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic5and3.text`) }}</p>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic5and4.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic5and4.text`) }}</p>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic5and5.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic5and5.text`) }}</p>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic5and6.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic5and6.text`) }}</p>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic5and7.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic5and7.text`) }}</p>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic5and8.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic5and8.text`) }}</p>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic5and9.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic5and9.text`) }}</p>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic6.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic6and1.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic6and2.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic6and3.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic7.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic7and1.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic7and2.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic7and3.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic7and4.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic7and5.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic7and6.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic7and7.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic8.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic8and1.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic8and2.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic9.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic9and1.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic9and1.text`) }}</p>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic10.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic10and1.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic11.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic11and1.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic11and2.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic12.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic12and1.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic12and2.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic12and3.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic12and4.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic12and5.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic12and6.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic12and7.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic13.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic13and1.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic13and2.title`) }}</h4>
        <br />
        <ul class="mt-3">
          <li class="term-text" v-for="item in $t(`termosAndCondition.topics.topic13and2.items`)" :key="item">&bull; {{ item }}</li>
        </ul>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic14.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic14and1.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic14and2.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic14and3.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic14and4.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic14and5.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic15.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic15and1.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic15and2.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic16.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic15and1.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic16and2.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic17.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic17and1.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic17and2.title`) }}</h4>
        <br />
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic18.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic18.text`) }}</p>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic19.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic19.text`) }}</p>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic20.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic20.text`) }}</p>
      </div>
      <div>
        <h4 class="mt-4">{{ $t(`termosAndCondition.topics.topic21.title`) }}</h4>
        <br />
        <p class="term-text">{{ $t(`termosAndCondition.topics.topic21.text`) }}</p>
      </div>
      <br /><br />
    </div>
  </page>
</template>

<script>
import page from './Page.vue'

export default {
  name: 'TermsAndConditions',
  components: {
    page,
  },

  data() {
    return {
      listItems: [],
    }
  },

  computed: {},

  mounted() {},

  methods: {},

  watch: {},
}
</script>

<style>
.text-center {
  text-align: center;
}

.term-text {
  font-size: 22px;
  line-height: 1.3em;
}

.text-header4 h4 {
  line-height: 1.3em;
}
</style>
